module.exports = __webpack_public_path__ + "img/4.c844b54d.svg";